module.exports = __webpack_public_path__ + "assets/images/coin1C.png";


//////////////////
// WEBPACK FOOTER
// ./client/app/assets/images/coin1C.png
// module id = 1511
// module chunks = 1